export const stringsKey = "CountryList";
export const englishStrings = {
	projectName: "Project Name",
	countryCode: "Country Code",
	exclusionList: "Unsupported Template Types",
	connectivity: "Connectivity",
	action: "Action",
	editBtnTooltip: "Edit",
	deleteBtnTooltip: "Delete",
	addBtnTooltip: "Add Country",
	deleteCountrySuccessMessage: "Country detail deleted successfully!",
	deleteCountryErrorMessage:
		"Error submitting delete country request, Please try again.",
	deleteConfirmationMessage: "Are you sure you want to delete record of",
	projectListErrorMessage: "Failed to load project list!",
};
